<template>
  <div class="auth-wrapper-provider">
    <SendCode
      v-if="state === 'SEND_CODE'"
      :label="currentCourseTitle"
      leftIcon=""
      :isLoginWithUsername="false"
      @goBack="goToActiveRegistrations"
    >
      <template #alertBox>
        <Alert
          class="margin-bottom-24"
          :text="$lang.detail_registrations_alert_text"
        />
      </template>
    </SendCode>
    <VerifyCode v-if="state === 'VERIFY_CODE'" />
    <DynamicField
      v-if="state === 'DYNAMIC_FORM'"
      :label="currentCourseTitle"
      :dynamicFieldCaption="dynamicFieldCaption"
      :hasNationalCode="hasNationalCode"
    />
  </div>
</template>

<script>
import { Alert } from "@/components/re-design";
import SendCode from "../components/SendCode.vue";
import VerifyCode from "../components/VerifyCode.vue";
import DynamicField from "../components/DynamicField.vue";
import { computed } from "vue";
import { mapGetters } from "vuex";
import { pathOr } from "ramda";
import { goToRoute } from "@/shared/utils";
import {
  getDetailRegistrations,
  sendMobile,
  confirmMobile,
} from "@/modules/auth/services";

export default {
  name: "auth-mobile",
  components: {
    Alert,
    SendCode,
    VerifyCode,
    DynamicField,
  },
  provide() {
    // provide this data to all deep child components
    return {
      MOBILE: computed(() => this.mobile),
      EXPIRE_SECONDS: computed(() => this.expireSeconds),
      setState: this.setState,
      goToContactUs: this.goToContactUs,
      goBack: this.goToActiveRegistrations,
      goToActiveRegistrations: this.goToActiveRegistrations,
      submitSendCode: this.submitSendCode,
      submitVerifyCode: this.submitVerifyCode,
    };
  },
  data() {
    return {
      state: "SEND_CODE",
      mobile: null,
      controlCode: null,
      expireSeconds: null,
      dynamicFieldCaption: null,
    };
  },
  computed: {
    ...mapGetters("auth", [
      "currentCourse",
      "preRegisterCode",
      "hasNationalCode",
    ]),
    currentCourseTitle() {
      return pathOr("", ["link_caption"], this.currentCourse);
    },
  },
  created() {
    this.getCurrentRegistrations();
  },
  methods: {
    pathOr,
    goToRoute,
    setState(state) {
      this.state = state;
    },
    goToContactUs() {
      goToRoute("contact-us", {}, {}, false);
    },
    goToActiveRegistrations() {
      goToRoute("active-registrations", {}, {}, false);
    },
    goToAuth() {
      goToRoute("auth", {}, {}, false);
    },
    async getCurrentRegistrations() {
      try {
        const code = this.$route.params.code;
        await getDetailRegistrations(code);
      } catch (error) {
        this.$generateError(error);
        goToRoute("active-registrations", {}, {}, false);
      }
    },
    async submitSendCode(mobile, captcha, key) {
      try {
        const code = pathOr(null, ["code"], this.currentCourse);
        const response = await sendMobile(code, mobile, captcha, key);
        const { controlCode, resExpireSeconds, message } = response;
        this.mobile = mobile;
        this.controlCode = controlCode;
        this.expireSeconds = resExpireSeconds;
        this.$notify.success(message);
        this.setState("VERIFY_CODE");
      } catch (error) {
        this.$generateError(error);
      }
    },
    async submitVerifyCode(code) {
      try {
        const response = await confirmMobile(code);
        const { registerStatus, dynamicFieldCaption, message } = response;
        this.dynamicFieldCaption = dynamicFieldCaption;
        this.$notify.success(message);

        /*
         * register_done => successfully and completed register and redirect to register result page
         * register_with_code => redirect to insert code form
         * register_without_code => redirect to identity form for insert information
         */
        if (registerStatus === "register_with_code") {
          this.setState("DYNAMIC_FORM");
        }
        if (registerStatus === "register_without_code") {
          goToRoute("personal-information", {}, {}, false);
        }
        if (registerStatus === "register_done") {
          goToRoute("result-registrations", {}, {}, false);
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
